// Shared presentation-only lookup. Gameplay admission stays in PlayAuthorization.
import { commercialPlayEnabled } from './PlayAuthorization';
import { getStudentPlaySession } from './ProgressData';

export function createMissionContentAccess(scene, onChange = () => {}) {
  const commercial = commercialPlayEnabled();
  const studentId = scene.registry.get('studentIdentity')?.student_id;
  let state = !commercial ? 'off' : studentId ? 'loading' : 'guest';
  let active = true;
  let generation = 0;
  let binding;
  const sameStudent = () => scene.registry.get('studentIdentity')?.student_id === studentId;
  const current = () => sameStudent() && binding?.isCurrent() === true;
  const update = next => { state = next; onChange(); };

  function refresh() {
    if (!active || !commercial || !studentId) return;
    const run = ++generation;
    update('loading');
    try {
      if (!sameStudent()) throw new Error('Student session changed');
      binding = getStudentPlaySession(studentId);
      if (!current()) throw new Error('Student session changed');
    } catch { update('error'); return; }
    const requestBinding = binding;
    Promise.resolve().then(() => {
      if (!active || run !== generation || !current()) return;
      return requestBinding.request('/student/content-access');
    }).then(data => {
      if (!active || run !== generation) return;
      if (!current()) { update('error'); return; }
      update(data?.premium === true ? 'premium' : data?.premium === false ? 'free' : 'error');
    }).catch(() => {
      if (active && run === generation) update('error');
    });
  }
  function sessionChanged() {
    if (active && commercial && studentId && (!sameStudent() || (binding && !current()))) {
      generation += 1;
      update('error');
    }
  }
  const cleanup = () => {
    active = false;
    generation += 1;
    window.removeEventListener('focus', refresh);
    window.removeEventListener('tmag:progress-status', sessionChanged);
    scene.events.off('shutdown', cleanup);
    scene.events.off('destroy', cleanup);
  };
  scene.events.once('shutdown', cleanup);
  scene.events.once('destroy', cleanup);
  if (commercial && studentId) {
    window.addEventListener('focus', refresh);
    window.addEventListener('tmag:progress-status', sessionChanged);
    // Callbacks run after the scene has finished building its controls.
    Promise.resolve().then(refresh);
  }
  function getState() {
    return commercial && studentId && (!sameStudent() || (binding && !current())) ? 'error' : state;
  }
  return {
    commercial,
    getState,
    refresh,
    allows(index) {
      return active && (!commercial || (sameStudent() && (!binding || current()) &&
        (index === 0 || getState() === 'premium')));
    },
  };
}
